import { Injectable } from '@angular/core';
import { AppSettings } from '../shared/App-Settings';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '../core/authentication.service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ResponseDTO } from '../models/response-dto';
import { CustomerFilterOption } from '../searchFilters/CustomerFilterOption';
import { SupportRequestSearchFilter } from '../models/supportRequestSearchFilter';

const apiUrl = AppSettings.API_BASE_URL + "api/CustomerSupportRequest/";
const apiCollectionUrl = AppSettings.API_BASE_URL + "api/CustomerSupportRequestCollection";
const apiInternalSupportrequestCollectionUrl = AppSettings.API_BASE_URL + "api/InternalSupportRequestCollection";
const apiInternalSuppotRequest = AppSettings.API_BASE_URL + "api/InternalSupportRequest/";
const supportRequestNotification = AppSettings.API_BASE_URL + "api/SupportRequestNotifications";

@Injectable({
  providedIn: 'root'
})
export class SupportrequestService {

  supportRequestNotificationObservable: Observable<any> = new Observable<any>();
  private currentValue: BehaviorSubject<any>;

  constructor(private httpClient: HttpClient, private auth: AuthenticationService) {
    this.currentValue = new BehaviorSubject<any>(1);
    this.supportRequestNotificationObservable = this.currentValue.asObservable();
  }

  pushNext() {
    this.currentValue.next(1);
  }

  private handleError<T>(operation = 'operation', result?: T) {
    let errorMsg = '';
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getSupportRequests(currentPage: number, pageSize: number, order: string, sortby: string, supportRequestSearchFilter: SupportRequestSearchFilter): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiCollectionUrl}`;

    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (supportRequestSearchFilter.trackingNumber)
      url = url + '&TrackingNumber=' + supportRequestSearchFilter.trackingNumber;

    if (supportRequestSearchFilter.country)
      url = url + '&Country=' + supportRequestSearchFilter.country;

    if (supportRequestSearchFilter.ticketId)
      url = url + '&CustomerSupportRequestCode=' + supportRequestSearchFilter.ticketId;

    if (supportRequestSearchFilter.raisedby)
      url = url + '&raisedby=' + supportRequestSearchFilter.raisedby;

    if (supportRequestSearchFilter.customerId)
      url = url + '&customerId=' + supportRequestSearchFilter.customerId;

    if (supportRequestSearchFilter.status)
      url = url + '&Status=' + supportRequestSearchFilter.status;

    if (supportRequestSearchFilter.warehouseId)
      url = url + '&WarehouseId=' + supportRequestSearchFilter.warehouseId;

    if (supportRequestSearchFilter.isSearch)
      url = url + '&IsSearch=' + supportRequestSearchFilter.isSearch;

    if (supportRequestSearchFilter.franchiseId)
      url = url + '&FranchiseId=' + supportRequestSearchFilter.franchiseId;

    return this.httpClient.get<any>(url, httpOptions);
  }

  deleteCustomerSupportRequest(CustomerSupportRequestId: number): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}${CustomerSupportRequestId}`;

    return this.httpClient.delete<any>(url, httpOptions);
  }

  deleteInternalSupportRequest(InternalsupportRequestId: number): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiInternalSuppotRequest}${InternalsupportRequestId}`;

    return this.httpClient.delete<any>(url, httpOptions);
  }

  getInternalSupportRequests(currentPage: number, pageSize: number, order: string, sortby: string, supportRequestSearchFilter): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiInternalSupportrequestCollectionUrl}`;

    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (supportRequestSearchFilter.trackingNo)
      url = url + '&TrackingNumber=' + supportRequestSearchFilter.trackingNo;

    if (supportRequestSearchFilter.country)
      url = url + '&Country=' + supportRequestSearchFilter.country;

    if (supportRequestSearchFilter.ticketId)
      url = url + '&InternalSupportRequestCode=' + supportRequestSearchFilter.ticketId;

    if (supportRequestSearchFilter.raisedby)
      url = url + '&raisedby=' + supportRequestSearchFilter.raisedby;

    if (supportRequestSearchFilter.categoryId)
      url = url + '&categoryId=' + supportRequestSearchFilter.categoryId;

    return this.httpClient.get<any>(url, httpOptions);
  }

  getSupportRequest(supportRequestId: number, IsCustomerSupportRequest): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url;
    if (IsCustomerSupportRequest)
      url = `${apiUrl}${supportRequestId}`;
    else
      url = `${apiInternalSuppotRequest}${supportRequestId}`;

    return this.httpClient.get<any>(url, httpOptions);
  }

  updateSupportRequestStatus(model, supportRequestId: number, IsCustomerSupportRequest): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url;

    if (!IsCustomerSupportRequest)
      url = `${apiInternalSuppotRequest}${supportRequestId}`;
    else
      url = `${apiUrl}${supportRequestId}`;

    return this.httpClient.patch<any>(url, { status: model }, httpOptions);
  }

  addInternalSupportRequest(model, filesToUpload): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let formData = new FormData();

    for (var i = 0; i < filesToUpload.length; i++) {
      formData.append("files", filesToUpload[i], filesToUpload[i]["name"]);
    }

    for (var key in model) {
      if (model.hasOwnProperty(key)) {
        var val = model[key];
        formData.append(key, val);
      }
    }
    let url = `${apiInternalSuppotRequest}`;
    return this.httpClient.post<any>(url, formData, httpOptions);
  }

  assignSupportRequest(supportRequestId: number, userId): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}${supportRequestId}/` + 'AssignTo?userId=' + userId;

    return this.httpClient.patch<any>(url, {}, httpOptions);
  }

  addSupportRequest(model, filesToUpload: File[]): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let formData = new FormData();

    for (var i = 0; i < filesToUpload.length; i++) {
      formData.append("files", filesToUpload[i], filesToUpload[i]["name"]);
    }
    for (var key in model) {
      if (model.hasOwnProperty(key)) {
        var val = model[key];
        formData.append(key, val);
      }
    }
    let url = `${apiUrl}`;
    return this.httpClient.post<any>(url, formData, httpOptions);
  }

  getSupportRequestNotification(): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${supportRequestNotification}`;

    return this.httpClient.get<any>(url, httpOptions);
  }

  markAsReadSupportRequest(supportRequestId): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiInternalSuppotRequest}${supportRequestId}/MarkAsRead`;

    return this.httpClient.patch<any>(url, {}, httpOptions);
  }
}
